module.exports = __webpack_public_path__ + "static/img/weather-bg-4.ec1099d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-4.gif
// module id = xk0u
// module chunks = 1